(() => {
  const hiddenAttribute = 'data-coeur-stay-teaser-hidden';

  const normalize = (value) => value.replace(/\s+/g, ' ').trim().toUpperCase();

  const isStayTeaserStep = (step) => {
    const text = normalize(step.innerText || step.textContent || '');

    return text.startsWith('STAY IN TOUCH') && !text.includes('STAY CONNECTED');
  };

  const isAtLandingTop = () => {
    if (!document.body.classList.contains('template-index')) return false;

    const landing = document.querySelector('.coeur-home-landing');
    if (!landing) return false;

    return window.scrollY <= 8;
  };

  const setWrapperHidden = (wrapper, shouldHide) => {
    if (shouldHide) {
      wrapper.setAttribute(hiddenAttribute, 'true');
      wrapper.style.setProperty('display', 'none', 'important');
      return;
    }

    if (wrapper.hasAttribute(hiddenAttribute)) {
      wrapper.removeAttribute(hiddenAttribute);
      wrapper.style.removeProperty('display');
    }
  };

  const syncStayTeaserVisibility = () => {
    document.querySelectorAll('[id^="mcforms-"]').forEach((wrapper) => {
      const root = wrapper.shadowRoot;
      if (!root) return;

      const visibleSteps = Array.from(root.querySelectorAll('.step')).filter(
        (step) => window.getComputedStyle(step).display !== 'none'
      );
      const hasVisibleStayTeaser = visibleSteps.some(isStayTeaserStep);

      if (!hasVisibleStayTeaser) {
        setWrapperHidden(wrapper, false);
        return;
      }

      setWrapperHidden(wrapper, !isAtLandingTop());
    });
  };

  const observeMailchimpWrappers = () => {
    document.querySelectorAll('[id^="mcforms-"]').forEach((wrapper) => {
      if (wrapper.dataset.coeurStayTeaserObserved === 'true' || !wrapper.shadowRoot) return;

      wrapper.dataset.coeurStayTeaserObserved = 'true';
      new MutationObserver(syncStayTeaserVisibility).observe(wrapper.shadowRoot, {
        attributes: true,
        childList: true,
        subtree: true,
      });
    });
  };

  const sync = () => {
    observeMailchimpWrappers();
    syncStayTeaserVisibility();
  };

  new MutationObserver(sync).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('scroll', syncStayTeaserVisibility, { passive: true });
  window.addEventListener('resize', syncStayTeaserVisibility);
  document.addEventListener('DOMContentLoaded', sync);
  sync();
})();
